<template>
  <div class="main">
    <base-card v-for="toast in toasts" :key="toast.name">
      <v-card-title>{{ toast.name }}</v-card-title>
      <v-card-text>{{ toast.text }}</v-card-text>
      <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        {{ toast.priceS }} <br />
        {{ toast.priceL }}
      </v-card-actions>
    </base-card>
    <base-card color="#DC143C">
      <v-card-title class="flex text-center">Sides</v-card-title>
    </base-card>
    <base-card v-for="side in sides" :key="side.name">
      <v-card-title>{{ side.name }}</v-card-title>
      <v-card-text>{{ side.text }}</v-card-text>
      <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        {{ side.priceS }} <br />
        {{ side.priceL }}
      </v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toasts: [
        {
          name: "Mushrooms and cheese",
          text: "Mushrooms and cheese",
          priceS: "small 120 den.",
          priceL: "large 140 den.",
        },
        {
          name: "Chicken ham and cheese",
          text: "Chicken ham and cheese",
          priceS: "small 100 den.",
          priceL: "large 120 den.",
        },
        {
          name: "Beef kulen and cheese",
          text: "Beef kulen and cheese",
          priceS: "small 140 den.",
          priceL: "large 160 den.",
        },
        {
          name: "Smoked ham and cheese",
          text: "Smoked ham and cheese",
          priceS: "small 140 den.",
          priceL: "large 160 den.",
        },
        {
          name: "Vegan toast",
          text: "Mushrooms and vegan cheese",
          priceS: "small 100 den.",
          priceL: "large 130 den.",
        },
      ],
      sides: [
        {
          name: "Dairy cheese",
          text: "With dairy cheese",
          priceS: "in small toast +30 den.",
          priceL: "in large toast +40 den.",
        },
        {
          name: "Fries",
          text: "With fries",
          priceS: "in small toast +30 den.",
          priceL: "in large toast +40 den.",
        },
        {
          name: "Mushrooms",
          text: "With mushrooms",
          priceS: "in small toast +30 den.",
          priceL: "in large toast +40 den.",
        },
        {
          name: "Salad",
          text: "With small toast",
          priceS: "in small toast +20 den.",
          priceL: "in large toast +30 den.",
        }
      ]
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 60vh;
  background: transparent;
}
</style>
